<template>
  <v-container grid-list-xs>
    <v-layout row wrap align-center>
      <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
        <h1 class="display-1">Account Info</h1>
        <p>Please provide the details below in order to create your new account.</p>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 sm10 offset-sm1 md8 offset-md2>
        <v-form 
          @submit.prevent="submit()"
          v-model="valid"
          ref="form"
          lazy-validation
          class="mb-5 pb-5"
        >
          <v-layout row wrap>
            <v-flex xs12 sm6 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
              <v-text-field
              label="First Name"
              v-model="newUser.fname"
              :rules="[rules.required]"
              required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
              label="Last Name" 
              v-model="newUser.lname"
              :rules="[rules.required]"             
              required></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
              label="Address"
              v-model="newUser.address1" 
              :rules="[rules.required, rules.streetAddress]"  
              validate-on-blur         
              required></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
              <v-text-field
              label="Unit/Apartment #"
              v-model="newUser.unitNumber" 
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
              <v-text-field
              v-model="newUser.address3" 
              label="PO Box"              
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-text-field
              label="Postal Code"  
              hint="Format: A1A A1A"
              persistent-hint
              v-model="newUser.postalCode" 
              :rules="[rules.required, rules.postalCode]"
              validate-on-blur
              required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 :class="{ 'pr-2': $vuetify.breakpoint.smAndUp }">
              <v-text-field
              label="City"    
              v-model="newUser.city" 
              :rules="[rules.required]"          
              required></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select
                label="Select a Province"
                v-model="newUser.province"
                :items="provinces"
                :rules="[rules.required]"
                required
                bottom
                item-text="name"
                item-value="val"
              ></v-select>
            </v-flex>            
          </v-layout>   
          <v-layout row wrap class="mt-3">
            <v-flex xs12>
              <v-text-field
              label="Email Address"  
              v-model="newUser.email"    
              :rules="[rules.required, rules.email]"         
              required></v-text-field>
            </v-flex>
          </v-layout>  
          <v-layout row wrap>
            <v-flex xs12>
              <v-text-field
                name="password"
                label="Password"
                hint="Minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character @$!%*#&^"
                :min="minPasswordLength"
                ref="password"
                required
                :rules="[rules.required, rules.passwordValid]"
                v-model="newUser.password"
                :append-icon="passwordVisibile ? 'visibility_off' : 'visibility'"
                :append-icon-cb="() => (passwordVisibile = !passwordVisibile)"
                :type="passwordVisibile ? 'text' : 'password'"
                hide-details
              ></v-text-field>

              <v-progress-linear value="0" height="5" color="grey" v-model="passwordStrength" :data-score="passwordStrength"></v-progress-linear>

              <v-text-field
                name="password-conf"
                label="Confirm Password"
                hint="Minimum 8 characters, at least 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character @$!%*#&^"
                :min="minPasswordLength"
                ref="passwordConfirm"
                required
                v-model="passwordConfirm"
                :append-icon="passwordVisibile ? 'visibility_off' : 'visibility'"
                :append-icon-cb="() => (passwordVisibile = !passwordVisibile)"
                :rules="[rules.matches]"
                :type="passwordVisibile ? 'text' : 'password'"
              ></v-text-field>
            </v-flex>
          </v-layout>  
          <v-layout row wrap>
            <v-flex xs6 class="text-xs-left">
              <v-btn
                @click="goBack"
                class="ml-0"
                outline
                color="secondary"
              >&laquo; Back</v-btn>
            </v-flex>
            <v-flex xs6 class="text-xs-right">
              <v-btn outline primary type="submit" :loading="loading" :disabled="loading === true || valid === false" class="mr-0 mb-4">
                Next &raquo;
              </v-btn>
            </v-flex>
          </v-layout>    
        </v-form>        
      </v-flex>      
    </v-layout>
    <v-snackbar
      :timeout="0"
      color="error"
      vertical="vertical"
      :value="alertMessage != null"
    >
      <span v-html="alertMessage"></span>
      <v-btn dark flat @click.native="alertMessage = null">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// import Password from 'vue-password-strength-meter'
import zxcvbn from "zxcvbn";
export default {
  // components: { Password },
  data() {
    return {
      valid: true,
      alertMessage: null,
      passwordConfirm: "",
      passwordVisibile: false,
      minPasswordLength: 8,
      newUser: {
        fname: null,
        lname: null,
        address1: null,
        address2: null,
        address3: null,
        province: null,
        city: null,
        postalCode: null,
        email: null,
        password: null
      },
      provinces: [
        { name: "Alberta", val: "AB" },
        { name: "British Columbia", val: "BC" },
        { name: "Manitoba", val: "MB" },
        { name: "New Brunswick", val: "NB" },
        { name: "Newfoundland & Labrador", val: "NL" },
        { name: "Nova Scotia", val: "NS" },
        { name: "Ontario", val: "ON" },
        { name: "Prince Edward Island", val: "PE" },
        { name: "Quebec", val: "QC" },
        { name: "Saskatchewan", val: "SK" },
        { name: "Northwest Territories", val: "NT" },
        { name: "Nunavut", val: "NU" },
        { name: "Yukon", val: "YT" }
      ],
      rules: {
        required: v => {
          return !!v || "Required";
        },
        email: v => {
          if (this.brand.rules.email) {
            return this.brand.rules.email(v);
          } else {
            return /^\w+([.+-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid";
          }
        },
        streetAddress: v => {
          let result = /(.?\d{1,}.?\d{0,})\s([a-zA-Z]{1,30}\s.+)/.exec(v);
          return (result && result.length === 3) || "Enter a valid address";
        },
        postalCode: v => {
          return (
            /^[abceghjklmnprstvxyABCEGHJKLMNPRSTVXY][0-9][abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ][\s]{0,1}[0-9][abceghjklmnprstvwxyzABCEGHJKLMNPRSTVWXYZ][0-9]$/.test(
              v
            ) || "Invalid postal code"
          );
        },
        passwordValid(v) {
          return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#&^])[A-Za-z\d@$!%*#&^]{8,}$/.test(v);
        },
        matches: () => {
          return this.passwordsMatch || "Password's must match.";
        }
      }
    };
  },
  computed: {
    passwordStrength() {
      return this.newUser.password ? zxcvbn(this.newUser.password).score : null;
    },
    isSecure() {
      return this.newUser.password ? this.newUser.password.length >= this.minPasswordLength : null;
    },
    passwordsMatch() {
      return (
        this.newUser.password !== "" &&
        this.passwordConfirm !== "" &&
        this.newUser.password === this.passwordConfirm
      );
    },
    accountId() {
      return this.$store.getters.accountId;
    },
    error() {
      return this.$store.getters.error;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  watch: {
    accountId(value) {
      if (value !== null && value !== undefined) {
        // for the time being, we'll disable the verification until we confirm how it will work. Until then,
        // we'll move to the PIN verification screen.
        // this.$router.push({ name: 'verify-email', params: { accountId: this.accountId, user: this.newUser } })
        this.$router.push({ name: "verify-pin" });
      }
    },
    error(val) {
      if (!val) {
        this.alertMessage = null;
        return;
      }

      var status = val.response.status;
      switch (status) {
        case 403:
          this.alertMessage = `An account with that email already exists. You can <a href="${
            this.$router.resolve({ name: "forgot-password" }).href
          }">reset your password</a> if you've forgotten it.`;
          break;

        case 500:
        default:
          this.alertMessage = "Oops, Something went wrong. Please try again later.";
          break;
      }
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch("createUserAccount", this.newUser)
          .then(() => {
            // if (this.$store.getters.user) {
            //   this.$router.push({name: 'select-plan'})
            // } else {
            //   console.error('Some error occurred.')
            // }
          })
          .catch(e => {
            console.log("error: ", e);
          });
      } else {
        console.log("invalid...");
      }
    },
    onDismissed() {
      this.$store.dispatch("clearError");
    }
  }
};
</script>

<style lang="scss" scoped>
.progress-linear[data-score="0"] /deep/ .progress-linear__bar__determinate {
  background: darkred !important;
  width: 20% !important;
}
.progress-linear[data-score="1"] /deep/ .progress-linear__bar__determinate {
  background: orangered !important;
  width: 40% !important;
}
.progress-linear[data-score="2"] /deep/ .progress-linear__bar__determinate {
  background: orange !important;
  width: 60% !important;
}
.progress-linear[data-score="3"] /deep/ .progress-linear__bar__determinate {
  background: yellowgreen !important;
  width: 80% !important;
}
.progress-linear[data-score="4"] /deep/ .progress-linear__bar__determinate {
  background: green !important;
  width: 100% !important;
}

// Snackbar links in white
.snack.error /deep/ .snack__content a {
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/components/activation/NewActivation.vue